import * as React from "react";

function SvgCircleInCircle(props) {
  return <svg width={24} height={24} viewBox="0 0 24 24" {...props}><g fill="currentColor" fillRule="evenodd"><path d="M12 0a12 12 0 110 24 12 12 0 010-24zm0 1a11 11 0 100 22 11 11 0 000-22z" fillRule="nonzero" /><path d="M12 19.2a7.2 7.2 0 100-14.4 7.2 7.2 0 000 14.4z" /></g></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/circle-in-circle_19564f.svg";
export { SvgCircleInCircle as ReactComponent };